import React from 'react';
import { placeholderImage } from '../utils/placeholderImage';

const AboutPage = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="hero section-full-width" style={{
        backgroundImage: 'url(/images/IMG_2044.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}>
        <div className="hero-content">
          <h1>About Nagi's Ceylon</h1>
          <p>
            Bringing the authentic taste of Sri Lanka to Perth, one dish at a time.
          </p>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="section">
        <div className="d-grid" style={{ gridTemplateColumns: '1fr 1fr', gap: '4rem', alignItems: 'center' }}>
          <div>
            <h2>Our Story</h2>
            <p>
              Nestled in the vibrant culinary landscape of Perth, Nagi's Ceylon stands as a testament to the passion and dedication of its founders, Nagina and Mahesh. Born and raised in Sri Lanka, Nagina and Mahesh grew up surrounded by the tantalizing aromas and bold spices that define Ceylonese cooking.
            </p>
            <p>
              For Nagi and Mahesh, Nagi's Ceylon is more than just a restaurant—it's a celebration of diversity and cultural exchange. By infusing their dishes with the exotic spices that are synonymous with Sri Lankan cuisine, they hope to transport diners on a sensory journey to the Pearl of the Indian Ocean.
            </p>
            <p>
              From aromatic curries infused with cinnamon, cloves, and cardamom to mouthwatering seafood dishes seasoned with turmeric and fenugreek, each recipe is a symphony of spices that dance on the palate and awaken the senses.
            </p>
          </div>
          <div>
            <img
              src="/images/Logo.png"
              alt="Nagi's Ceylon Logo"
              style={{
                width: '100%',
                height: '400px',
                objectFit: 'contain',
                borderRadius: '15px',
                backgroundColor: '#f8f9fa'
              }}
              onError={(e) => {
                e.target.src = placeholderImage;
              }}
            />
          </div>
        </div>
      </section>

      {/* Our Mission Section */}
      <section className="section-full-width" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="section-title">
          <h2>Our Mission</h2>
          <p>
            To provide Perth with an authentic Sri Lankan dining experience while preserving and celebrating 
            our rich culinary heritage.
          </p>
        </div>
      </section>

      {/* Key Pillars Section */}
      <section className="section">
        <div className="d-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
          <div className="card p-3 text-center">
            <div className="mb-2">
              <div style={{ 
                width: '60px', 
                height: '60px', 
                borderRadius: '50%', 
                backgroundColor: '#ffe6e6', 
                border: '2px solid #ff6b35',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto',
                fontSize: '1.5rem',
                color: '#ff6b35'
              }}>
                ✓
              </div>
            </div>
            <h3>Authenticity</h3>
            <p>
              We use traditional recipes and cooking methods to ensure every dish reflects the true taste of Sri Lanka.
            </p>
          </div>

          <div className="card p-3 text-center">
            <div className="mb-2">
              <div style={{ 
                width: '60px', 
                height: '60px', 
                borderRadius: '50%', 
                backgroundColor: '#e6f7ff', 
                border: '2px solid #ff6b35',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto',
                fontSize: '1.5rem',
                color: '#ff6b35'
              }}>
                👥
              </div>
            </div>
            <h3>Community</h3>
            <p>
              Building connections within the Perth community and introducing new friends to Sri Lankan culture through food.
            </p>
          </div>

          <div className="card p-3 text-center">
            <div className="mb-2">
              <div style={{ 
                width: '60px', 
                height: '60px', 
                borderRadius: '50%', 
                backgroundColor: '#fff3e0', 
                border: '2px solid #ff6b35',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto',
                fontSize: '1.5rem',
                color: '#ff6b35'
              }}>
                ✓
              </div>
            </div>
            <h3>Quality</h3>
            <p>
              Using only the finest ingredients and spices, sourced both locally and from Sri Lanka, 
              to create exceptional dining experiences.
            </p>
          </div>
        </div>
      </section>

      {/* Meet Our Team Section */}
      <section className="section-full-width" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="section-title">
          <h2>Meet Our Team</h2>
          <p>
            The passionate people behind Nagi's Ceylon, dedicated to bringing you authentic Sri Lankan flavors.
          </p>
        </div>

        <div className="d-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
          <div className="card p-3 text-center">
            <img
              src="/images/nagina.jpg"
              alt="Nagina Perera"
              style={{
                width: '150px',
                height: '150px',
                borderRadius: '50%',
                objectFit: 'cover',
                margin: '0 auto 1rem'
              }}
              onError={(e) => {
                e.target.src = '/images/placeholder.jpg';
              }}
            />
            <h3>Nagina Perera</h3>
            <p style={{ color: '#ff6b35', fontWeight: '600' }}>Founder & Head Chef</p>
            <p>
              The heart and soul of Nagi's Ceylon, Nagina brings over 30 years of culinary expertise 
              and a deep passion for authentic Sri Lankan cuisine. Her traditional recipes and cooking 
              methods ensure every dish tells a story of heritage and love.
            </p>
          </div>

          <div className="card p-3 text-center">
            <img
              src="/images/mahesh.jpg"
              alt="Mahesh Perera"
              style={{
                width: '150px',
                height: '150px',
                borderRadius: '50%',
                objectFit: 'cover',
                margin: '0 auto 1rem'
              }}
              onError={(e) => {
                e.target.src = '/images/placeholder.jpg';
              }}
            />
            <h3>Mahesh Perera</h3>
            <p style={{ color: '#ff6b35', fontWeight: '600' }}>Co-Founder & Operations Manager</p>
            <p>
              Mahesh oversees the day-to-day operations and ensures that every aspect of our service 
              meets the highest standards. His commitment to excellence and customer satisfaction 
              drives our continued success.
            </p>
          </div>

          <div className="card p-3 text-center">
            <img
              src="/images/kitchen-team.jpg"
              alt="Our Kitchen Team"
              style={{
                width: '150px',
                height: '150px',
                borderRadius: '50%',
                objectFit: 'cover',
                margin: '0 auto 1rem'
              }}
              onError={(e) => {
                e.target.src = '/images/placeholder.jpg';
              }}
            />
            <h3>Our Kitchen Team</h3>
            <p style={{ color: '#ff6b35', fontWeight: '600' }}>Dedicated Chefs</p>
            <p>
              Our talented team of chefs work together to bring you the most authentic Sri Lankan 
              flavors. Each member brings their unique skills and passion to create memorable dining experiences.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="section">
        <div className="section-title">
          <h2>Our Values</h2>
        </div>

        <div className="d-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem' }}>
          <div className="text-center p-3">
            <h3>Family Tradition</h3>
            <p>Every recipe tells a story of our family's journey and cultural heritage.</p>
          </div>
          <div className="text-center p-3">
            <h3>Fresh Ingredients</h3>
            <p>We source the finest ingredients to ensure authentic flavors and quality.</p>
          </div>
          <div className="text-center p-3">
            <h3>Community Focus</h3>
            <p>Building lasting relationships with our customers and the Perth community.</p>
          </div>
          <div className="text-center p-3">
            <h3>Sustainability</h3>
            <p>Committed to environmentally responsible practices in our operations.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage; 